module.exports = __webpack_public_path__ + "media/images/icons/material/cogs-60b1f67e11841a1541690782f303f9b7.svg";